import React, { Component } from "react";
import { Modal, GET, Pagination, t } from "../CustomComponent.js";
import { setSelectedCustomer } from "../../utils/customerScope";

const PAGE_SIZE = 8;

/**
 * modal เลือกลูกค้าสำหรับพนักงานภายในที่เข้าพอร์ทัลลูกค้า
 *
 * เลือกแล้วเก็บลง localStorage (`cm-cs-customer`) และ reload หน้าเดิม เพื่อให้ทุกหน้า
 * ยิง API ใหม่พร้อม header `customer-uid` ของลูกค้ารายที่เลือก
 *
 * @param {boolean} show
 * @param {Function} [onHide] - ไม่ส่งมา = บังคับเลือก (ปิดเองไม่ได้)
 * @param {string} [selectedUid] - ลูกค้าที่เลือกอยู่ตอนนี้ (ไฮไลต์ในรายการ)
 */
export default class CustomerPickerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      customers: [],
      count: 0,
      page: 1,
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.show) this.Get(1);
  }

  componentDidUpdate(prevProps) {
    // เปิด modal ครั้งใหม่ -> โหลดรายการใหม่เสมอ
    if (!prevProps.show && this.props.show) this.Get(1);
  }

  Get = async (page = 1) => {
    this.setState({ loading: true });

    const result = await GET("customer/context/customers", {
      page,
      page_size: PAGE_SIZE,
      data_search: this.state.filter_search || "",
    });

    this.setState({
      customers: result?.status === true && Array.isArray(result.data) ? result.data : [],
      count: result?.pagination?.count || 0,
      page,
      loading: false,
    });
  };

  onSearch = (e) => {
    e.preventDefault();
    this.Get(1);
  };

  onSelect = (customer) => {
    setSelectedCustomer({
      uid: customer.uid,
      name: customer.name,
      customer_code: customer.customer_code,
    });

    if (this.props.onSelected) {
      this.props.onSelected(customer);
      return;
    }

    // reload เพื่อให้หน้าที่เปิดอยู่ดึงข้อมูลของลูกค้ารายใหม่
    window.location.reload();
  };

  render() {
    const { show, onHide, selectedUid } = this.props;
    const { customers, count, page, filter_search, loading } = this.state;

    return (
      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header className="border-0 pb-2">
          <div>
            <Modal.Title className="fw-bold">{t("select_customer_portal")}</Modal.Title>
            <div className="text-secondary text-13 mt-1">{t("select_customer_portal_desc")}</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.onSearch} className="d-flex gap-2 mb-3">
            <input
              className="form-control rounded-3"
              placeholder={t("search_customer_placeholder")}
              value={filter_search}
              onChange={(e) => this.setState({ filter_search: e.target.value })}
            />
            <button type="submit" className="btn btn-primary px-4 fw-bold rounded-3">
              <span className="icon me-2">{"\uf002"}</span>
              {t("search")}
            </button>
          </form>

          {loading ? (
            <div className="text-center text-secondary py-5">{t("loading")}</div>
          ) : customers.length === 0 ? (
            <div className="text-center text-secondary py-5">{t("customer_not_found")}</div>
          ) : (
            <div className="d-flex flex-column gap-2">
              {customers.map((customer) => {
                const isSelected = selectedUid && selectedUid === customer.uid;
                return (
                  <button
                    key={customer.uid}
                    type="button"
                    onClick={() => this.onSelect(customer)}
                    className={`btn text-start border rounded-3 p-3 d-flex align-items-center bg-white ${isSelected ? "border-primary" : "border-light"}`}
                  >
                    <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center icon text-18 me-3 flex-shrink-0">
                      {"\uf1ad"}
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <div className="fw-bold text-dark text-truncate">{customer.name}</div>
                      <div className="text-secondary text-12 text-truncate">
                        {[customer.customer_code, customer.province, customer.phone].filter(Boolean).join(" · ")}
                      </div>
                    </div>
                    <div className="text-secondary text-12 ms-3 flex-shrink-0">
                      {customer.asset_count} {t("assets_unit")}
                    </div>
                  </button>
                );
              })}
            </div>
          )}

          {count > PAGE_SIZE && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination
                count={Math.ceil(count / PAGE_SIZE)}
                page={page}
                onChange={(e, value) => this.Get(value)}
                shape="rounded"
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}
